import React from "react";
import "./resume.style.css";

const Resume = () => {
  return (
    <div id="resume">
      <a
        href="https://drive.google.com/file/d/1kNFeEymDbGuZwbrO-KbanLdo2H9QC6iE/view?usp=share_link"
        target="_blank"
        rel="noopener noreferrer"
      >
        Resume
      </a>
    </div>
  );
};

export default Resume;
